module.exports = __webpack_public_path__ + "Assets/Images/templates/thumbnails/Nonprofit-Awareness-and-Donation-Information.jpg";